import classNames from "classnames";

export function ModifySettingsButton(
	props: React.HTMLProps<HTMLButtonElement> & { hide_arrow?: boolean }
) {
	const { hide_arrow, ...html_props } = props;

	return (
		<button
			{...html_props}
			className={classNames(
				"font-bold text-sesh-primary hover:text-sesh-dark hover:underline",
				props.className,
				{ "input-disabled": props.disabled }
			)}
			type="button"
		>
			<div className="flex items-center gap-2">
				<span>{props.children}</span>
				{props.disabled && (
					<span>
						<i key="lock-button-icon" className="fas fa-lock"></i>
					</span>
				)}
				{!props.disabled && !props.hide_arrow && (
					<span>
						<i key="button-icon" className="fas fa-arrow-right"></i>
					</span>
				)}
			</div>
		</button>
	);
}
